import { ICommand } from 'core-ts-types';
import * as _4 from 'lodash4';
import { CommunicatorService } from 'ui-ng-component-communicator';
import { PlatformUtility } from 'utility-ts-platform';
import { Survey } from '../../builders/survey_builder';
import { SurveyQuery } from '../../queries/survey_query';
import { SurveyQuestionQuery } from '../../queries/survey_question_query';
import { SurveyQuestionDirectionStrategy } from '../../strategies/survey_question_direction_strategy';

export interface IComponent {
  submit?: () => void;
}
export class SurveyQuestionFooterController {
  private flags: {
    isLoading: boolean;
    isSubmitting: boolean;
    hasFormError: boolean;
  };
  private isDesktop: boolean;

  private isSubmittingBound: () => void;
  private isNotSubmittingBound: () => void;

  constructor(
    private ngComponentCommunicatorService: CommunicatorService,
    private ngSurveyQuestionQuery: SurveyQuestionQuery,
    private ngSurveyQuery: SurveyQuery,
    private loadSurveyQuestionCommand: ICommand,
    private $state: ng.ui.IStateService,
    private $stateParams: ng.ui.IStateParamsService
  ) {
    this.flags = {
      isLoading: false,
      isSubmitting: false,
      hasFormError: false
    };
    this.isDesktop = PlatformUtility.isDesktop();
  }

  $onInit() {
    this.isSubmittingBound = this.isSubmitting.bind(this);
    this.isNotSubmittingBound = this.isNotSubmitting.bind(this);
    this.ngComponentCommunicatorService.subscribe('SURVEY_QUESTION_IS_SUBMITTING', this.isSubmittingBound);
    this.ngComponentCommunicatorService.subscribe('SURVEY_QUESTION_NOT_SUBMITTING', this.isNotSubmittingBound);
  }

  get survey() {
    return _4.find(this.ngSurveyQuery.result, (survey: Survey) => survey.id === this.$stateParams.surveyID);
  }

  isSubmitting() {
    this.flags.isSubmitting = true;
  }

  isNotSubmitting() {
    this.flags.isSubmitting = false;
  }
  submit() {
    const form = _4.first(angular.element('#survey-question-form')) as IComponent;
    if (!_4.isUndefined(form) && form.submit) {
      form.submit();
    }
  }

  loadPreviousQuestion() {
    const surveyID = _4.get(this, 'survey.id');
    const direction = SurveyQuestionDirectionStrategy.getByKey('PRIOR');

    if (!_4.isUndefined(surveyID)) {
      this.loadSurveyQuestionCommand(surveyID, direction.queryName).then(() => {
        this.ngComponentCommunicatorService.publish('SURVEY_QUESTION_GOTO_PRIOR');
        if (_4.isEmpty(this.ngSurveyQuestionQuery.result.question)) {
          this.$state.go(direction.newState, { surveyID });
        }
      });
    }
  }
}

export class SurveyQuestionFooterComponent implements angular.IComponentOptions {
  public templateUrl: string = 'capability-ng-survey/src/components/survey_question_footer/survey_question_footer.html';
  public controller: object = SurveyQuestionFooterController;
  public controllerAs: string = '$ctrl';
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-survey/src/components/survey_question_footer/survey_question_footer.ts